import { render, staticRenderFns } from "./AdminNaehrwerte.vue?vue&type=template&id=cbe483f8&"
import script from "./AdminNaehrwerte.vue?vue&type=script&lang=js&"
export * from "./AdminNaehrwerte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports